import AdminWorkingHours from '../admin/WorkingHours';
export default AdminWorkingHours;
